import React, { Children, Component } from 'react';
import classNames from 'classnames';
import shallowEqual from 'shallowequal';
import Radio from './radio';
import ConfigContext from '../config-provider/ConfigContext';
import { RadioContextProvider } from './RadioContext';
function getCheckedValue(children) {
    let value = null;
    let matched = false;
    Children.forEach(children, (radio) => {
        if (radio && radio.props && radio.props.checked) {
            value = radio.props.value;
            matched = true;
        }
    });
    return matched ? { value } : undefined;
}
export default class RadioGroup extends Component {
    constructor(props, context) {
        super(props, context);
        this.onRadioChange = (ev) => {
            const { value: lastValue } = this.state;
            const { value } = ev.target;
            if (!('value' in this.props)) {
                this.setState({
                    value,
                });
            }
            const { onChange } = this.props;
            if (onChange && value !== lastValue) {
                onChange(ev);
            }
        };
        let value;
        if ('value' in props) {
            value = props.value;
        }
        else if ('defaultValue' in props) {
            value = props.defaultValue;
        }
        else {
            const checkedValue = getCheckedValue(props.children);
            value = checkedValue && checkedValue.value;
        }
        this.state = {
            value,
        };
    }
    static get contextType() {
        return ConfigContext;
    }
    getContextValue() {
        const { disabled, name } = this.props;
        const { value } = this.state;
        return {
            radioGroup: {
                onChange: this.onRadioChange,
                value,
                disabled,
                name,
            },
        };
    }
    componentWillReceiveProps(nextProps) {
        if ('value' in nextProps) {
            this.setState({
                value: nextProps.value,
            });
        }
        else {
            const checkedValue = getCheckedValue(nextProps.children);
            if (checkedValue) {
                this.setState({
                    value: checkedValue.value,
                });
            }
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState);
    }
    render() {
        const { props } = this;
        const { prefixCls: customizePrefixCls, className = '', options, buttonStyle, size, label, disabled } = props;
        const { value } = this.state;
        const { getPrefixCls } = this.context;
        const prefixCls = getPrefixCls('radio', customizePrefixCls);
        const groupPrefixCls = `${prefixCls}-group`;
        const classString = classNames(groupPrefixCls, `${groupPrefixCls}-${buttonStyle}`, {
            [`${groupPrefixCls}-${size}`]: size,
        }, className);
        let { children } = props;
        // 如果存在 options, 优先使用
        if (options && options.length > 0) {
            children = options.map((option, index) => {
                if (typeof option === 'string') {
                    // 此处类型自动推导为 string
                    return (React.createElement(Radio, { key: String(index), prefixCls: prefixCls, disabled: disabled, value: option, onChange: this.onRadioChange, checked: value === option }, option));
                }
                // 此处类型自动推导为 { label: string value: string }
                return (React.createElement(Radio, { key: String(index), prefixCls: prefixCls, disabled: option.disabled || disabled, value: option.value, onChange: this.onRadioChange, checked: value === option.value }, option.label));
            });
        }
        const group = (React.createElement("div", { className: classString, style: props.style, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave, id: props.id },
            React.createElement(RadioContextProvider, Object.assign({}, this.getContextValue(), { getPrefixCls: getPrefixCls }), children)));
        if (label) {
            const wrapperClassString = classNames({
                [`${groupPrefixCls}-wrapper`]: true,
                [`${groupPrefixCls}-has-label`]: label,
            });
            const labelClassString = classNames(`${groupPrefixCls}-label`, {
                'label-disabled': disabled,
            });
            return (React.createElement("div", { className: wrapperClassString },
                React.createElement("span", { className: labelClassString }, label),
                group));
        }
        return group;
    }
}
RadioGroup.displayName = 'RadioGroup';
RadioGroup.defaultProps = {
    disabled: false,
    buttonStyle: 'outline',
};
